import { useQuery } from '@tanstack/react-query';
import getCeoCreditAgreements from '~apis/trade/getCeoCreditAgreements';

export const USE_CEO_CREDIT_REQUEST_QUERY = {
  root: ['ceo-credit-request'],
  default: (companyId: string, termRequestId: string) => [
    ...USE_CEO_CREDIT_REQUEST_QUERY.root,
    companyId,
    termRequestId,
  ],
};
export default function useCeoCreditRequestQuery(companyId: string, termRequestId: string) {
  return useQuery(
    USE_CEO_CREDIT_REQUEST_QUERY.default(companyId as string, termRequestId as string),
    () => getCeoCreditAgreements(companyId, termRequestId),
    {
      enabled: !!companyId && !!termRequestId,
    },
  );
}
